/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 798d000ef5fd
 */

import * as z from "zod";
import { uploadPresetsListUploadPresets } from "../../funcs/uploadPresetsListUploadPresets.js";
import { DirectionEnum$zodSchema } from "../../models/directionenum.js";
import { OrderBy$zodSchema } from "../../models/listuploadpresetsop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  order_by: OrderBy$zodSchema.optional().describe(
    `The field to sort presets by.`,
  ),
  direction: DirectionEnum$zodSchema.optional().describe(
    `The sort direction for the results. Default is "desc".`,
  ),
  max_results: z.int().default(10).describe(
    "The maximum number of results to return. Default is 10.",
  ),
  next_cursor: z.string().describe(
    "The cursor for pagination. Use the next_cursor value from a previous response to get the next page of results.",
  ).optional(),
};

export const tool$uploadPresetsListUploadPresets: ToolDefinition<typeof args> =
  {
    name: "list-upload-presets",
    description: `Lists all upload presets configured in the account`,
    scopes: ["builder"],
    annotations: {
      "title": "List Upload Presets",
      "destructiveHint": false,
      "idempotentHint": true,
      "openWorldHint": false,
      "readOnlyHint": true,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await uploadPresetsListUploadPresets(
        client,
        args.order_by,
        args.direction,
        args.max_results,
        args.next_cursor,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
